import {call, put, takeEvery} from 'redux-saga/effects';
import {PayloadAction} from "@reduxjs/toolkit";
import {api} from "../../api/api";
import {cardsActions} from "../cards.slice";
import {cardViewActions} from "../view/cardView.slice";

function* revertSaga(action: PayloadAction<string>) {
    const cardId = action.payload;

    yield put(cardViewActions.setReverting(true));
    try {
        yield call(api.revertCard, {cardId});
        yield put(cardsActions.loadCard(cardId));
    } catch (error) {
        window.alert(error instanceof Error ? error.message : 'Failed to revert card');
    } finally {
        yield put(cardViewActions.setReverting(false));
    }
}

export function* revertCardSaga() {
    yield takeEvery(cardsActions.revertCard.type, revertSaga);
}
